import React from 'react';
import { stringify } from '../../util/urlHelpers';
import { NamedLink, IconClose } from '../index';
import classNames from 'classnames';
import css from './Topbar.css';
import { useSelector, useDispatch } from 'react-redux';
import { setPromoBarOpen, selectIsPromoBarOpen } from '../../ducks/UI.duck';
import Lorry from './fast-delivery.svg';

const PromoBar = () => {
  const isPromoBarOpen = useSelector(selectIsPromoBarOpen);
  const dispatch = useDispatch();
  const [promoBarIndex, setPromoBarIndex] = React.useState(0);
  const promoBarTimer = React.useRef(null);

  React.useEffect(() => {
    if (process.env.REACT_APP_COUNTRY_ID !== 'pl' || !isPromoBarOpen) return;
    // On mount: check localStorage and update Redux if needed
    const closedTimestamp = localStorage.getItem('promoBarClosedAt');
    if (closedTimestamp) {
      const now = Date.now();
      const diff = now - parseInt(closedTimestamp, 10);
      if (diff < 24 * 60 * 60 * 1000) {
        dispatch(setPromoBarOpen(false));
      }
    }
    promoBarTimer.current = setInterval(() => {
      setPromoBarIndex(idx => (idx + 1) % 1);
    }, 10000);
    return () => {
      if (promoBarTimer.current) clearInterval(promoBarTimer.current);
    };
  }, [dispatch]);

  const handleClosePromoBar = () => {
    dispatch(setPromoBarOpen(false));
    localStorage.setItem('promoBarClosedAt', Date.now().toString());
  };

  if (process.env.REACT_APP_COUNTRY_ID !== 'pl' || !isPromoBarOpen) return null;

  const bars = [
    // {
    //   className: classNames(css.promoBar, css.promoBarRed),
    //   text: (
    //     <>
    //       <strong>Im dłużej jeździsz, tym mniej płacisz!</strong> Wypożycz sprzęt narciarski na min. 7 dni z kodem <strong>NARTY15</strong> a otrzymasz <strong>15%</strong> rabatu.
    //     </>
    //   ),
    //   linkName: 'AlpineSkiingSearchPage',
    //   // pageParams: { businessCategory: 'wintersports_alpineskiing', exact: true}
    // },
    // {
    //   className: classNames(css.promoBar, css.promoBarBlue),
    //   text: (
    //     <>
    //       <strong>Rozkręć swój weekend.</strong> Dodatkowe <strong>-15%</strong> z kodem <strong>WIOSNA15</strong> przy wypożyczeniu roweru na min. 3 dni.
    //     </>
    //   ),
    //   linkName: 'SearchPage',
    //   pageParams: { keywords: 'rower'}
    // },
     // {
    //  {
    //   className: classNames(css.promoBar, css.promoBarRed),
    //   text: (
    //     <>
    //       <strong>Spędź noc pod gwiazdami!</strong> Wypożycz sprzęt kempingowy i zyskaj <strong>-15%</strong> z kodem <strong>"NAMIOT15"</strong>
    //     </>
    //   ),
    //   linkName: 'CampingTentSearchPage',
    //   // pageParams: { businessCategory: 'camping_tent', exact: true}
    // },
    {
      className: classNames(css.promoBar, css.promoBarOrange),
      text: (
        <div className={css.wrap}>
          <img src={Lorry} className={css.lorryIcon}/>
          <strong>Wypożycz sprzęt sportowy z dostawą do domu lub innego miejsca w Polsce!</strong>
          <img src={Lorry} className={css.lorryIcon}/>
        </div>
      ),
      linkName: 'SearchPage',
      pageParams: { homeDelivery: true}
    }
  ];

  return (
    <div className={bars[promoBarIndex].className}>
      <div className={css.promoBarText}>
        <NamedLink id="promoBarLink" className={css.promoBarLink} name={bars[promoBarIndex].linkName} to={{ search: stringify(bars[promoBarIndex].pageParams || {}) }}>
          {bars[promoBarIndex].text}
        </NamedLink>
      </div>
      <span className={css.promoBarClose} onClick={handleClosePromoBar}>
        <IconClose />
      </span>
    </div>
  );
};

export default PromoBar;